module.exports = __webpack_public_path__ + "assets/main-min.d36d5734631dc71c1be977a1f2630be9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/WuikStudio/main-min.jpg
 ** module id = 404
 ** module chunks = 0
 **/